import RequestAccessPage from './request-access-page';

export default RequestAccessPage;